import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useAccountHoldersPageLogic } from '../hooks/useAccountHoldersPageLogic';
import AccountHoldersHeader from '../components/AccountHoldersHeader';
import AccountHoldersTable from '../components/AccountHoldersTable';
import { accountHolderAudienceTabs } from '../mappers/accountHoldersFormatters';
import { adminTabsSx } from '../../../styles/adminComponentStyles';

const AccountHoldersPage: React.FC = () => {
  const {
    search,
    searchInput,
    audienceFilter,
    owners,
    loading,
    loadingMore,
    error,
    deleteError,
    deletingOwnerId,
    handleSearchChange,
    handleAudienceFilterChange,
    handleTableScroll,
    handleOwnerClick,
    handleDeleteLead,
  } = useAccountHoldersPageLogic();

  return (
    <Box>
      <AccountHoldersHeader
        search={searchInput}
        onSearchChange={handleSearchChange}
      />
      <Box
        sx={{
          backgroundColor: 'rgb(239, 246, 255)',
          border: '1px solid rgba(163, 174, 208, 0.24)',
          borderRadius: '8px',
          marginBottom: '8px',
          paddingLeft: '12px', 
        }}
      >
        <Tabs
          value={audienceFilter}
          onChange={(_event, nextFilter) => handleAudienceFilterChange(nextFilter)}
          sx={adminTabsSx}
        >
          {accountHolderAudienceTabs.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
      </Box>
      <AccountHoldersTable
        owners={owners}
        search={search}
        audienceFilter={audienceFilter}
        loading={loading}
        loadingMore={loadingMore}
        error={error}
        deleteError={deleteError}
        deletingOwnerId={deletingOwnerId}
        onTableScroll={handleTableScroll}
        onOwnerClick={handleOwnerClick}
        onDeleteLead={handleDeleteLead}
      />
    </Box>
  );
};

export default AccountHoldersPage;
